'use strict';

/**
 * Module front PUR (testable) — normalisation des champs COMMUNS du payload de simulation.
 *
 * Extrait VERBATIM de la partie sans DOM de `calculateEligible()`, dupliquée à l'identique dans
 * `simulation.js` et `simulation_borne.js` sur ses 8 champs de base. Les champs variant-spécifiques
 * (town + étudiant côté web, `simulation_token` côté borne) restent dans chaque appelant.
 *
 * Aucune dépendance jQuery : le `$.trim(...)` d'origine est remplacé par `String.prototype.trim`,
 * strictement équivalent ici (les chaînes concernées ont déjà eu leurs espaces retirés par `.replace(/ /g,'')`,
 * donc `trim` comme `.replace(' FCFP','')` sont des no-op — comportement inchangé, `parseInt` s'arrête de
 * toute façon au premier non-chiffre « FCFP »).
 *
 * @param {Object} dataObject     formulaire déjà normalisé par `transformKeyObject` (clés `simulation_*`)
 * @param {*}      simulationType  type de simulation courant (repris tel quel)
 * @returns {Object} les 8 champs de base de `currentValue`
 */
function buildSimulationPayloadBase(dataObject, simulationType) {
    var pmmString = dataObject.simulation_pmm.replace(/ /g, '');
    var rmmString = dataObject.simulation_rmm.replace(/ /g, '');
    return {
        simulation_type: simulationType,
        pmm: parseInt(pmmString.replace(' FCFP', '')) || 0,
        amount_of_adults: parseInt(dataObject.simulation_number_of_adult) || 0,
        amount_of_children: parseInt(dataObject.simulation_number_of_child) || 0,
        person_with_reduced_mobility: dataObject.simulation_is_pmr_presence === 'yes',
        victim_of_natural_disaster: dataObject.simulation_is_victim_of_natural_disaster === 'yes',
        simulation_particular_conditions: parseInt(dataObject.simulation_particular_conditions) || 0,
        rmm: parseInt(rmmString.replace(' FCFP', '').trim()) || 0
    };
}

module.exports = buildSimulationPayloadBase;
